// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-header.title::after {
  height: var(--unit-xxxsm);
  bottom: calc(var(--unit-xxxsm) * -1);
}
ion-header.title ion-title {
  color: var(--Labels-Primary, #000);
  text-align: center;
  font-family: "Poppins";
  font-size: 17px;
  font-style: normal;
  font-weight: 590;
  line-height: 22px;
  position: relative;
  top: 0px;
}
ion-header.title .subtitle {
  padding-inline: var(--unit-lg);
  width: 100%;
}
ion-header.title .subtitle ion-label {
  font-size: var(--font-md);
  font-weight: 400;
  --color: var(--ion-color-info-text);
}

ion-toolbar .close-icon {
  width: 32px;
  height: 32px;
}

.ios-modal ion-toolbar:first-of-type {
  padding-top: 0px !important;
}

.config-title {
  color: var(--ion-color-primary);
}

ion-header ion-toolbar {
  --background: #fff;
}
ion-header ion-toolbar ion-icon {
  margin-right: 16px;
}

ion-header.search {
  background: transparent;
  padding: var(--unit-md);
}
ion-header.search::after {
  background-image: none;
}

ion-content {
  --background: var(--ion-color-primary-contrast);
  --padding-bottom: var(--unit-xxxsm);
}

ion-footer {
  --background: transparent;
}
ion-footer ion-toolbar {
  --border-width: 0;
  --padding-end: 0;
  --padding-start: 0;
  border-top-left-radius: var(--radius-md);
  border-top-right-radius: var(--radius-md);
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.15);
}
ion-footer ion-grid ion-button {
  width: auto;
}

#container-actions {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  border-bottom: 1px solid #f0f0f0;
}
#container-actions .cancel,
#container-actions .accept {
  color: var(--ion-color-primary);
  text-align: right;
  font-feature-settings: "liga" off, "clig" off;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: -0.4px;
  font-size: 14px !important;
  text-transform: initial;
}
#container-actions .title {
  color: #000;
  text-align: center;
  font-family: "Poppins";
  font-size: 14px !important;
  text-transform: initial;
  font-style: normal;
  font-weight: 590;
  line-height: 18px;
}

.container-date {
  border-radius: 16px;
  border: 1px solid #f6f6f6;
  background: #FFF;
  border: 2px solid #ede9e9;
  min-height: 56px;
}

.custom-item-form {
  border-radius: 16px;
  border: 1px solid #f6f6f6;
  background: #FFF;
  border: 2px solid #ede9e9;
  margin-bottom: 16px;
  --padding-start: 16px;
  --padding-end: 16px;
}
.custom-item-form .single-p {
  color: #425F81 !important;
  font-feature-settings: "liga" off, "clig" off;
  font-family: "Roboto";
  font-size: 16px !important;
  font-weight: 400;
}
.custom-item-form .icon-select {
  width: 16px;
  height: 16px;
}
.custom-item-form ion-chip {
  border-radius: 8px;
  background: var(--Background, #F3F3F3);
  color: var(--text-BODY, #2C4051);
  font-feature-settings: "liga" off, "clig" off;
  font-family: "Poppins";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.container-datetime {
  --background: #fff;
}

.no-border {
  box-shadow: none;
  border: none;
  margin-bottom: 0px;
}

.custom-item-form ::ng-deep .custom-input .label-text {
  color: #425F81 !important;
  font-feature-settings: "liga" off, "clig" off;
  font-family: "Roboto";
  font-size: 16px !important;
}
.custom-item-form ::ng-deep .custom-input {
  color: #2C4051;
  font-feature-settings: "liga" off, "clig" off;
  font-family: "Poppins";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  padding-left: 0px;
}

#historyDetail {
  padding: 0px 16px;
}
#historyDetail ion-item {
  --padding-start: 0px;
  --padding-end: 0px;
}
#historyDetail ion-item ion-label {
  margin-bottom: 8px;
  margin-top: 8px;
}
#historyDetail ion-item ion-label h2 {
  color: var(--text-Info, #788089);
  font-family: "Poppins";
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
#historyDetail ion-item ion-label p {
  color: var(--text-BODY, #2C4051);
  font-feature-settings: "liga" off, "clig" off;
  font-family: "Poppins";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.container-update {
  margin-top: 30px;
  margin-bottom: 60px;
}
.container-update p {
  font-family: "Poppins";
  font-weight: 600;
}

.no-email {
  margin-top: 0px;
  font-weight: 500;
  font-size: 14px;
  margin-bottom: 20px;
}

.order-id {
  font-size: 17px;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/app/components/upsert-sheet/upsert-sheet.component.scss"],"names":[],"mappings":"AACE;EACE,yBAAA;EACA,oCAAA;AAAJ;AAGE;EACE,kCAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,QAAA;AADJ;AAIE;EACE,8BAAA;EACA,WAAA;AAFJ;AAII;EACE,yBAAA;EACA,gBAAA;EACA,mCAAA;AAFN;;AAOA;EACE,WAAA;EACA,YAAA;AAJF;;AAOA;EACE,2BAAA;AAJF;;AAOA;EACE,+BAAA;AAJF;;AAQE;EACE,kBAAA;AALJ;AAOI;EACE,kBAAA;AALN;;AAUA;EACE,uBAAA;EACA,uBAAA;AAPF;AASE;EACE,sBAAA;AAPJ;;AAWA;EACE,+CAAA;EACA,mCAAA;AARF;;AAWA;EACE,yBAAA;AARF;AAUE;EACE,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,wCAAA;EACA,yCAAA;EACA,2CAAA;AARJ;AAYI;EACE,WAAA;AAVN;;AAeA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,6BAAA;EACA,gCAAA;AAZF;AAcE;;EAEE,+BAAA;EACA,iBAAA;EACA,6CAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,0BAAA;EACA,uBAAA;AAZJ;AAeE;EACE,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,0BAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAbJ;;AAiBA;EACE,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,yBAAA;EACA,gBAAA;AAdF;;AAiBA;EACE,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;AAdF;AAgBE;EACE,yBAAA;EACA,6CAAA;EACA,qBAAA;EACA,0BAAA;EACA,gBAAA;AAdJ;AAiBE;EACE,WAAA;EACA,YAAA;AAfJ;AAkBE;EACE,kBAAA;EACA,sCAAA;EAEA,gCAAA;EACA,6CAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAjBJ;;AAqBA;EACE,kBAAA;AAlBF;;AAqBA;EACE,gBAAA;EACA,YAAA;EACA,kBAAA;AAlBF;;AAsBE;EAQE,yBAAA;EACA,6CAAA;EACA,qBAAA;EACA,0BAAA;AA1BJ;AA6BE;EACE,cAAA;EACA,6CAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;AA3BJ;;AA+BA;EACE,iBAAA;AA5BF;AA6BE;EACE,oBAAA;EACA,kBAAA;AA3BJ;AA6BI;EACE,kBAAA;EACA,eAAA;AA3BN;AA6BM;EACE,gCAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AA3BR;AA8BM;EACE,gCAAA;EACA,6CAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AA5BR;;AAiCA;EACE,gBAAA;EACA,mBAAA;AA9BF;AAgCE;EACE,sBAAA;EACA,gBAAA;AA9BJ;;AAkCA;EACE,eAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;AA/BF;;AAkCA;EACE,eAAA;EACA,kBAAA;AA/BF","sourcesContent":["ion-header.title {\n  &::after {\n    height: var(--unit-xxxsm);\n    bottom: calc(var(--unit-xxxsm) * -1);\n  }\n\n  ion-title {\n    color: var(--Labels-Primary, #000);\n    text-align: center;\n    font-family: \"Poppins\";\n    font-size: 17px;\n    font-style: normal;\n    font-weight: 590;\n    line-height: 22px;\n    position: relative;\n    top: 0px;\n  }\n\n  .subtitle {\n    padding-inline: var(--unit-lg);\n    width: 100%;\n\n    ion-label {\n      font-size: var(--font-md);\n      font-weight: 400;\n      --color: var(--ion-color-info-text);\n    }\n  }\n}\n\nion-toolbar .close-icon {\n  width: 32px;\n  height: 32px;\n}\n\n.ios-modal ion-toolbar:first-of-type {\n  padding-top: 0px !important;\n}\n\n.config-title {\n  color: var(--ion-color-primary);\n}\n\nion-header {\n  ion-toolbar {\n    --background: #fff;\n\n    ion-icon {\n      margin-right: 16px;\n    }\n  }\n}\n\nion-header.search {\n  background: transparent;\n  padding: var(--unit-md);\n\n  &::after {\n    background-image: none;\n  }\n}\n\nion-content {\n  --background: var(--ion-color-primary-contrast);\n  --padding-bottom: var(--unit-xxxsm);\n}\n\nion-footer {\n  --background: transparent;\n\n  ion-toolbar {\n    --border-width: 0;\n    --padding-end: 0;\n    --padding-start: 0;\n    border-top-left-radius: var(--radius-md);\n    border-top-right-radius: var(--radius-md);\n    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.15);\n  }\n\n  ion-grid {\n    ion-button {\n      width: auto;\n    }\n  }\n}\n\n#container-actions {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-around;\n  border-bottom: 1px solid #f0f0f0;\n\n  .cancel,\n  .accept {\n    color: var(--ion-color-primary);\n    text-align: right;\n    font-feature-settings: \"liga\" off, \"clig\" off;\n    font-family: 'Poppins';\n    font-style: normal;\n    font-weight: 400;\n    line-height: 18px;\n    letter-spacing: -0.4px;\n    font-size: 14px !important;\n    text-transform: initial;\n  }\n\n  .title {\n    color: #000;\n    text-align: center;\n    font-family: \"Poppins\";\n    font-size: 14px !important;\n    text-transform: initial;\n    font-style: normal;\n    font-weight: 590;\n    line-height: 18px;\n  }\n}\n\n.container-date {\n  border-radius: 16px;\n  border: 1px solid #f6f6f6;\n  background: #FFF;\n  border: 2px solid #ede9e9;\n  min-height: 56px;\n}\n\n.custom-item-form {\n  border-radius: 16px;\n  border: 1px solid #f6f6f6;\n  background: #FFF;\n  border: 2px solid #ede9e9;\n  margin-bottom: 16px;\n  --padding-start: 16px;\n  --padding-end: 16px;\n\n  .single-p {\n    color: #425F81 !important;\n    font-feature-settings: \"liga\" off, \"clig\" off;\n    font-family: \"Roboto\";\n    font-size: 16px !important;\n    font-weight: 400;\n  }\n\n  .icon-select {\n    width: 16px;\n    height: 16px;\n  }\n\n  ion-chip {\n    border-radius: 8px;\n    background: var(--Background, #F3F3F3);\n\n    color: var(--text-BODY, #2C4051);\n    font-feature-settings: 'liga' off, 'clig' off;\n    font-family: 'Poppins';\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n  }\n}\n\n.container-datetime {\n  --background: #fff;\n}\n\n.no-border {\n  box-shadow: none;\n  border: none;\n  margin-bottom: 0px;\n}\n\n.custom-item-form {\n  ::ng-deep .custom-input .label-text {\n    // color: var(--ion-color-primary);\n    // font-family: 'Poppins';\n    // font-size: 12px;\n    // font-style: normal;\n    // font-weight: 500;\n    // line-height: normal;\n\n    color: #425F81 !important;\n    font-feature-settings: \"liga\" off, \"clig\" off;\n    font-family: \"Roboto\";\n    font-size: 16px !important;\n  }\n\n  ::ng-deep .custom-input {\n    color: #2C4051;\n    font-feature-settings: 'liga' off, 'clig' off;\n    font-family: 'Poppins';\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n    padding-left: 0px;\n  }\n}\n\n#historyDetail {\n  padding: 0px 16px;\n  ion-item {\n    --padding-start: 0px;\n    --padding-end: 0px;\n\n    ion-label {\n      margin-bottom: 8px;\n      margin-top: 8px;\n\n      h2 {\n        color: var(--text-Info, #788089);\n        font-family: 'Poppins';\n        font-size: 12px;\n        font-style: normal;\n        font-weight: 500;\n        line-height: normal;\n      }\n\n      p {\n        color: var(--text-BODY, #2C4051);\n        font-feature-settings: 'liga' off, 'clig' off;\n        font-family: 'Poppins';\n        font-size: 16px;\n        font-style: normal;\n        font-weight: 400;\n        line-height: normal;\n      }\n    }\n  }\n}\n.container-update{\n  margin-top: 30px;\n  margin-bottom: 60px;\n\n  p{\n    font-family: 'Poppins';\n    font-weight: 600;\n  }\n}\n\n.no-email{\n  margin-top: 0px;\n  font-weight: 500;\n  font-size: 14px;\n  margin-bottom: 20px;\n}\n\n.order-id{\n  font-size: 17px;\n  text-align: center;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
